import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhonelinkOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phonelink_off"}/>
}
